<template>
    <div class="login__input-pills-container">
        <div class="login__input-pills" @click="toggle">
            <div class="login__input-pill">
                <input type="radio" v-model="internalValue"
                    :value="false" autocomplete="off"  />
                <label for="signIn">
                    <span>Sign in</span>
                </label>
            </div>
            <div class="login__input-pill">
                <input type="radio" v-model="internalValue"
                    :value="true" autocomplete="off"/>
                <label for="guest">
                    <span>Guest Checkout</span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        guest: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        internalValue: {
            get() {
                return this.guest;
            },
            set(value) {
                this.$emit('toggle-guest', value);
            }
        }
    },
    methods: {
        toggle() {
            this.internalValue = !this.internalValue;
        }
    }
};
</script>